import { Component } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { UserType } from '../../../Shared/Enums/UserType';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { LoginVm } from '../../../Model/LoginVM';

@Component({
  selector: 'app-price-offers',
  templateUrl: './price-offers.component.html',
  styleUrl: './price-offers.component.scss'
})
export class PriceOffersComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  ContractsList: DtoContractClientForViewVM[] = [];
  OriginalContractsList: DtoContractClientForViewVM[] = [];
  currentUser: LoginVm = {};

  constructor(private contractApi: ContractsWarrantiesService, private auth: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Client])) {
      this.spinner.show();
      this.GetCurrentUser();
      if (this.currentUser.userType == UserType.Workshop) {
        this.GetAllContracts();
      }
      else if (this.currentUser.userType == UserType.Client) {
        this.GetAllContractByClient();
      }
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetCurrentUser() {
    let jsonObj = this.auth.getStorage("currentUser");
    this.currentUser = <LoginVm>JSON.parse(jsonObj);
  }

  GetAllContracts() {
    if (this.auth.isAuthenticated([UserType.Workshop])) {
      this.contractApi.GetAllContracts()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.ContractsList = data.payload;
              this.OriginalContractsList = data.payload;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllContractByClient() {
    if (this.auth.isAuthenticated([UserType.Client])) {
      this.contractApi.GetAllContractByClient()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.spinner.hide();
              this.ContractsList = data.payload;
              this.OriginalContractsList = data.payload;
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetFilteredList(event: any) {
    this.ContractsList = [];
    if (event.list?.length > 0) {
      this.ContractsList = event.list;
    }
  }
}
